module.exports = __webpack_public_path__ + "static/media/Alone.725b33f1.jpeg";